import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import {useForm} from "react-hook-form";
import classes from './form.module.scss';
import {useNavigate, useParams} from 'react-router-dom';
import errorMessage from "../../../../const/Tost";
import {patientTagData} from "./PatientTagData";
import {patientService} from "../../../../api/patientServices";

const EditPatient = () => {
    const {id} = useParams(); // Get the patient ID from the URL parameters
    const navigate = useNavigate(); // Initialize navigation function
    const [patientInfo, setPatientInfo] = useState({}); // State to hold patient information

    const {
        register,
        handleSubmit,
        formState: {errors},
        reset,
    } = useForm(); // Initialize form handling

    // Function to handle form submission
    const onSubmit = async(data) => {
        try{
            await patientService.editPatientInfo(id, data).then(res => {
                if (res) navigate('/PatientList');
            });
        } catch(error){
            errorMessage(error, error?.response?.data?.message); // Handle errors during submission
        }
    }

    useEffect(() => {
        patientService.getPatientInfo(id).then(res => {
            if (res?.data){ // Check if data is returned
                setPatientInfo(res.data); // Update state with patient data
                reset(res.data); // Reset form fields with fetched patient data
            }
        })
    }, [id, reset]); // Dependencies: re-run effect if ID or reset function changes

    return (
        <>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                <div className={classes.form__wrapper}>
                    <div className={classNames(classes.form__title)}>
                        Змінити існуючого пацієнта
                    </div>
                </div>
                {patientTagData?.fields?.map((el, index) => ( // Map over fields defined in patientTagData
                    <div className={classes[patientTagData.class]} key={index}>
                        <legend className={classes.form__label} htmlFor={el.type}>{el.legend}</legend>
                        <div
                            className={classNames(el.name == 'cassetsAfter' ? classes.form__input__cassets : classes.form__label__container, {[classes.register__container]: patientTagData.formType == 'patientTagData'})}>
                            {el?.options ? ( // Check if the field has options for a select element
                                <>
                                    <label>{el?.label}</label>
                                    <select
                                        name={el.name}
                                        className={classes.form__select}
                                        {...register(el.name)} // Register the select field with react-hook-form
                                    >
                                        {el?.props?.map((props, i) => ( // Map over options for the select
                                            <option key={props.id + i} className={classes.form__option} value={props.value}>
                                                {props.name}
                                            </option>
                                        ))}
                                    </select>
                                </>
                            ) : (<>
                                {patientInfo?.outside && el.name === 'phoneNumber' ? <></> : el?.props.map((props, i) => (
                                    <div
                                        className={classNames(classes.form__label__container__box, {[classes.register__container]: patientTagData.formType == 'patientTagData'})}
                                        key={'a' + i}>
                                        <div><label>{props.label}</label></div>
                                        {/* Field label */}
                                        <div className={el.name == 'cassetsAfter' ? classes.form__input__cassets : {}}>
                                            <input
                                                className={classNames(classes.form__input, {[classes.errorInput]: errors[el.name]})} // Apply error class if there are validation errors
                                                type={props.type} // Input type (e.g., text, email, tel, date)
                                                placeholder={props.placeholder} // Placeholder text
                                                defaultValue={el.name == 'birthDate' ? patientInfo[el.name]?.split('T')[0] : patientInfo[el.name] || ''} // Format date for input[type="date"]
                                                {...register(el.name, {
                                                    required: el.required,
                                                    pattern: el.pattern ? {value: new RegExp(el.pattern), message: "Invalid format"} : undefined // Custom pattern validation
                                                })} // Register input with validation
                                                onInput={(e) => {
                                                    // Allow only digits and + for telephone input
                                                    if (props.type == 'tel'){
                                                        let value = e.target.value.replace(/[^+\d]/g, '');

                                                        if (value[0] !== '+'){
                                                            value = '+' + value;
                                                        }

                                                        e.target.defaultValue = value;
                                                    }
                                                }}
                                                maxLength={el.max} // Limit the number of characters based on max property
                                            />

                                            {errors[el.name] && ( // Show error message if validation fails
                                                <p className={classNames('DefaultForm-input-hint', classes.errorHint)}>
                                                    {errors[el.name].message || "This field is required"}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                ))
                                }</>)}
                        </div>
                    </div>
                ))}
                <button className={classes.form__button} type="submit">Змінити</button>
            </form>
        </>
    );
}

export default EditPatient; // Export the component for use in other parts of the application
